import { useExtensionCartWatcher } from '$src/hooks/extensions';

/**
 * Component that activates the  extension cart watcher
 * Automatically executes extension actions when cart changes (discount codes, etc.)
 */
export const ExtensionCartWatcher: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Activate automatic cart watching for extension execution
  useExtensionCartWatcher();

  return children;
};
